export const apiHost = process.env.NEXT_PUBLIC_API_HOST ?? 'https://ppv-api.origin.barstool.dev'
export const unionApiHost =
  process.env.NEXT_PUBLIC_UNION_API_HOST ?? 'https://union-staging.barstoolsports.com/v2'
export const muxEnvKey = process.env.NEXT_PUBLIC_MUX_ENV_KEY

export const BANNER_AD_MOBILE = process.env.NEXT_PUBLIC_BANNER_AD_MOBILE
export const BANNER_AD_DESKTOP = process.env.NEXT_PUBLIC_BANNER_AD_DESKTOP
export const BANNER_AD_LINK = process.env.NEXT_PUBLIC_BANNER_AD_LINK
